import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	linkExternalIconLabel: {
		id: 'navigation.global-shortcuts.menu-link-item.link-external-item-label',
		description: 'Label for the link external icon',
		defaultMessage: 'Open external link icon',
	},
});
